import {Component, OnInit} from '@angular/core';
import {RestService} from '../services/rest.service';
import {UIBlockerService} from '../services/uiblocker.service';
import {Router} from '@angular/router';
import {DataService} from '../services/data.service';
import {SessionStorageService} from '../services/session-storage.service';
import {finalize, tap} from 'rxjs/operators';
import {NgForm} from '@angular/forms';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    sessionId: any;
    loginResponse: any;
    loginFailed = false;

    constructor(
        private restService: RestService,
        private uiBlockerService: UIBlockerService,
        private router: Router,
        private dataService: DataService,
        private localStorage: SessionStorageService
    ) { /* noop */
    }

    ngOnInit() {
        // should get data from local storage and if session is ok we should redirect to overview
        this.getDataFromLocalStorage();
    }

    getDataFromLocalStorage() {
        this.localStorage.getItem('SessionIdentifier').subscribe((data) => {
            // if we find a value we will quickly make a new api call to get guardion details (email and name) to

            // have them
            if (data === null || data === '') {
                // we do not have the session id so just stay on the login page - nithing else needed
            } else {
                // we have the sesion id so we will call the new check session id on blackhole
                this.checkSessionIdOnServer(data);
            }
        });
    }

    checkSessionIdOnServer(data: any) {
        // check session id on server
        this.restService.checkSession(data)
            .pipe(
                finalize(() => {
                    this.uiBlockerService.unBlockUI();
                }),
                tap(
                    () => {
                        /* noop */
                    },
                    () => {

                        // we must clear the current local storage since that value is not good
                        this.localStorage.clear().subscribe(() => { /* noop */
                        });
                    }
                )
            ).subscribe((res: any) => {
            if (this.dataService.isResponseSuccessful(res)) {
                // and now that we have the data we can redirect to the home page
                this.router.navigate(['/central/overview']);
            } else {
                // manage response not valid so we will stay on login page
                // session not valid remove from local storage
                this.localStorage.clear().subscribe(() => { /* noop */
                });
            }
        });
    }

    onSignin(form: NgForm) {

        this.loginFailed = false;
        if (form.valid) {
            this.uiBlockerService.blockUI();
            const user = form.value.username;
            const password = form.value.password;

            const userCredentials = {
                Username: user,
                Password: password
            };

            // then call the login service and based on the response redirect or not
            this.restService.login(userCredentials)
                .pipe(
                    finalize(() => {
                        this.uiBlockerService.unBlockUI();
                    }),
                    tap(
                        () => {
                            /* noop */
                        },
                        () => {

                            this.loginFailed = true;
                        }
                    )
                ).subscribe((res: any) => {
                if (this.dataService.isResponseSuccessful(res)) {
                    // and now that we have the data we can redirect to the home page
                    this.dataService.setUserInfo(res.UserInfo);
                    // since login was ok we can set the local storage with the new value
                    this.localStorage.setItem('SessionIdentifier', res.UserInfo.SessionIdentifier).subscribe(
                        () => { /* noop */
                        });

                    this.router.navigate(['/central/overview']);
                } else {
                    // manage response not ok
                    this.loginFailed = true;
                }
            });
        } else {
            // error
        }

    }

}
